/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Empty_State_Hint_SearchInputs */

const en_manual_qc_empty_state_hint_search = /** @type {(inputs: Manual_Qc_Empty_State_Hint_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Try adjusting your search or filters`)
};

const fr_manual_qc_empty_state_hint_search = /** @type {(inputs: Manual_Qc_Empty_State_Hint_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Essayez de modifier votre recherche ou vos filtres`)
};

const de_manual_qc_empty_state_hint_search = /** @type {(inputs: Manual_Qc_Empty_State_Hint_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Versuchen Sie, Ihre Suche oder Filter anzupassen.`)
};

const it_manual_qc_empty_state_hint_search = /** @type {(inputs: Manual_Qc_Empty_State_Hint_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prova a modificare la tua ricerca o i filtri`)
};

const ru_manual_qc_empty_state_hint_search = /** @type {(inputs: Manual_Qc_Empty_State_Hint_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Попробуйте изменить параметры поиска или фильтры.`)
};

const es_manual_qc_empty_state_hint_search = /** @type {(inputs: Manual_Qc_Empty_State_Hint_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intente ajustar su búsqueda o filtros`)
};

const zh_cn2_manual_qc_empty_state_hint_search = /** @type {(inputs: Manual_Qc_Empty_State_Hint_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`尝试调整搜索或筛选条件。`)
};

const ja_manual_qc_empty_state_hint_search = /** @type {(inputs: Manual_Qc_Empty_State_Hint_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`検索条件やフィルターを調整してみてください`)
};

const hi_manual_qc_empty_state_hint_search = /** @type {(inputs: Manual_Qc_Empty_State_Hint_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपनी खोज या फ़िल्टर को समायोजित करने का प्रयास करें`)
};

const pt_pt2_manual_qc_empty_state_hint_search = /** @type {(inputs: Manual_Qc_Empty_State_Hint_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tente ajustar sua pesquisa ou filtros.`)
};

/**
* | output |
* | --- |
* | "Try adjusting your search or filters" |
*
* @param {Manual_Qc_Empty_State_Hint_SearchInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_empty_state_hint_search = /** @type {((inputs?: Manual_Qc_Empty_State_Hint_SearchInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Empty_State_Hint_SearchInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_empty_state_hint_search(inputs)
	if (locale === "de") return de_manual_qc_empty_state_hint_search(inputs)
	if (locale === "it") return it_manual_qc_empty_state_hint_search(inputs)
	if (locale === "ru") return ru_manual_qc_empty_state_hint_search(inputs)
	if (locale === "es") return es_manual_qc_empty_state_hint_search(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_empty_state_hint_search(inputs)
	if (locale === "ja") return ja_manual_qc_empty_state_hint_search(inputs)
	if (locale === "hi") return hi_manual_qc_empty_state_hint_search(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_empty_state_hint_search(inputs)
	return en_manual_qc_empty_state_hint_search(inputs)
});